import React from 'react';
import RatingInput from '../components/RatingInput';


function ServiceRatingPage({handleDoctorRating, handleCARating}) {
  
  return (
    <div className='w-screen h-screen justify-items-center content-center p-10'>
      <img className='absolute top-0 right-10 w-1/4 h-auto' src={process.env.PUBLIC_URL + '/logo.png'} />
      <h1 className='justify-self-start text-2xl font-bold italic mb-10 underline'>How would you rate your service experience?</h1>

        <div className='w-full flex items-center justify-between' >
          <div className='w-1/3 justify-items-center'>
            <h1 className='w-fit border border-black px-6 py-2 font-bold text-2xl'>Doctor</h1>
          </div>
          <div className='grow'>
            <RatingInput handleRating={handleDoctorRating} size='mid' />
          </div>
        </div>

        <hr className='my-10 border-1 w-screen border-black' />
        <div className='w-full flex items-center justify-between'>
          <div className='w-1/3 justify-items-center'>
            <h1 className='w-fit border border-black px-6 py-2 font-bold text-2xl text-nowrap'>Clinic Assistant</h1>
          </div>
          <div className='grow'>
            <RatingInput handleRating={handleCARating} size='mid' />
          </div>
        </div>

    </div>
  );
}

export default ServiceRatingPage;